<template>
  <v-container fluid class="grey lighten-2" style="height:100%;">
    <v-row justify="center" align="center" style="height:100%;">
      <v-col cols="6">
        <v-card tile style="opacity: 0.8;">
          <v-card-title>
            <div>
              <v-icon x-large color="warning" class="mr-2">mdi-compass-off</v-icon>
              页面不存在
            </div>
            <v-spacer />
            <a class="body-1 mr-4" @click="$router.go(-1)">返回</a>
            <router-link class="text-decoration-none body-1 mr-4" to="/msgboard">联系客服</router-link>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="text-h5">
                抱歉，您访问的页面不存在...
              </v-col>
              <v-col cols="12">
                可能原因：
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-row dense class="pl-8">
                  <v-col cols="12">
                    网址有错误 > 请检查地址是否完整或存在多余字符；
                  </v-col>
                  <v-col cols="12">
                    网址已失效 > 可能页面已删除，或者产品已下线
                  </v-col>
                </v-row>

              </v-col>

            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

export default {

}
</script>